const serializeFormData = (values) => {
  const filteredValues = Object.fromEntries(Object.entries(values).filter(([, value]) => !!value))
  return new URLSearchParams(filteredValues)
}

export default serializeFormData
